import { Anchor, Breadcrumbs, Grid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['productFeed']}`;

const ProductFeedsStatisticsPage = () => {
  const fetch = useFetch();

  const [productFeed, setProductFeed] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, productFeedId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds/${productFeedId}`)
      .then(({ productFeed }) => setProductFeed(productFeed))
      .catch(setError);
  }, [accountId, domainId, productFeedId, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${productFeed?.name || 'Unnamed productFeed'}`} />
      <Breadcrumbs>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/productFeeds`}>{page}</Anchor>
        <Anchor>{productFeed?.name || 'Unnamed Product Feed'}</Anchor>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={productFeed?.name} scope="productFeeds" id={productFeedId} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default ProductFeedsStatisticsPage;
